<template>
        <div>
        <v-layout mb-3 justify-center >
          <h3 class="primary--text text-uppercase">{{$t('reservas.resumenGrafico.resumen')}}</h3>
        </v-layout>
        <v-layout justify-center v-in-viewport="() => {start = true}">
          <v-flex xs12 sm12 md10 lg8 xl5>
            <v-layout justify-center align-center>
              <v-flex hidden-xs-only sm4 md3 class="primary--text"/>
              <v-flex xs11 sm7 md8>
                <v-layout align-center>
                  <v-flex xs7 sm5 :style="estiloBorde">
                    <o-fade-transition>
                      <v-layout justify-end class="primary--text pa-2" style="font-size: 0.7rem" :key="start ? 'started' : 'paused'" :class="start ? 'started' : 'paused'">
                        {{$t('reservas.resumenGrafico.importe')}}
                      </v-layout>
                    </o-fade-transition>
                  </v-flex>
                  <o-fade-transition>
                    <v-flex xs5 sm7 class="primary--text px-2" style="font-size: 0.7rem" :key="start ? 'started' : 'paused'">
                      {{$t('reservas.resumenGrafico.masIva', {iva: $options.filters['decimalInput'](iva)})}}
                    </v-flex>
                  </o-fade-transition>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="primary--text">
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center align-center v-if="reserva > 0">
              <v-flex xs11 sm4 md3 class="primary--text">
                <v-layout align-center>
                  <v-flex xs7 sm12 pl-3 :style="$vuetify.breakpoint.xsOnly ? estiloBorde : ''">
                    <o-fade-transition :delay="600">
                      <div :key="start ? 'started' : 'paused'">
                        <i18n path="reservas.resumenGrafico.pago" tag="span" class="hidden-xs-only">
                          <template #num>1</template>
                          <template #sup><sup>{{$t('reservas.resumenGrafico.paso1')}}</sup></template>
                        </i18n>
                        {{$t('reservas.resumenGrafico.reserva')}}
                      </div>
                    </o-fade-transition>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex hidden-sm-and-up xs1/>
              <v-flex xs11 sm7 md8>
                <v-layout align-center>
                  <v-flex xs7 sm5 pb-2 pt-2 :style="estiloBorde">
                    <v-layout justify-end>
                      <o-scale-x-transition :delay="600" :right="false">
                        <span v-if="start" class="primary white--text text-xs-right pa-1 px-2" style="min-width:70px;">
                          <o-fade-transition :delay="1100">
                            <span>{{reserva | currency}}</span>
                          </o-fade-transition>
                        </span>
                      </o-scale-x-transition>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="iva != null" xs5 sm7 class="primary--text">
                    <v-layout align-center>
                      <o-scale-x-transition :delay="600">
                        <v-flex :key="start ? 'started' : 'paused'" class="primary--text rayas mr-2 xs1" style="max-width:20px;"/>
                      </o-scale-x-transition>
                      <o-fade-transition :delay="1100">
                        <span :key="start ? 'started' : 'paused'">{{reserva * iva / 100 | currency}}</span>
                      </o-fade-transition>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="primary--text text-xs-right pr-3">
              </v-flex>
            </v-layout>      
            <v-layout row wrap justify-center align-center class="primary--text bordeRayas" v-if="entrada > reserva">
              <v-flex xs11 sm4 md3 class="primary--text">
                <v-layout align-center>
                  <v-flex xs7 sm12 pl-3 :style="$vuetify.breakpoint.xsOnly ? estiloBorde : ''">
                    <o-fade-transition :delay="1100">
                      <div :key="start ? 'started' : 'paused'">
                        <i18n path="reservas.resumenGrafico.pago" tag="span" class="hidden-xs-only">
                          <template #num>{{pasoEntrada}}</template>
                          <template #sup><sup>{{$t('reservas.resumenGrafico.paso' + pasoEntrada)}}</sup></template>                            
                        </i18n>
                        {{$t('reservas.resumenGrafico.entrada')}}
                      </div>
                    </o-fade-transition>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex hidden-sm-and-up xs1/>
              <v-flex xs11 sm7 md8>
                <v-layout align-center>
                  <v-flex xs7 sm5 pb-2 pt-2 :style="estiloBorde">
                    <v-layout justify-end>
                      <o-scale-x-transition :right="false" :delay="1100">
                        <span :key="start ? 'started' : 'paused'" class="primary white--text text-xs-right pa-1 px-2" style="width:100px;">
                          <o-fade-transition :delay="1600">
                            <span :key="start ? 'started' : 'paused'">{{entrada - reserva | currency}}</span>
                          </o-fade-transition>
                        </span>
                      </o-scale-x-transition>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="iva != null" xs5 sm7 class="primary--text">
                    <v-layout align-center>
                      <o-scale-x-transition :delay="1100">
                        <v-flex :key="start ? 'started' : 'paused'" class="primary--text rayas mr-2" style="max-width:30px;"/>
                      </o-scale-x-transition>
                      <o-fade-transition :delay="1600">
                        <span :key="start ? 'started' : 'paused'">{{((entrada - reserva) * iva / 100) | currency}}</span>
                      </o-fade-transition>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="primary--text text-xs-right pr-3"
                :style="{
                  position: 'relative',
                  top: $vuetify.breakpoint.xsOnly ? '-43.5px' : '-22.5px'
                }"
              >
                <o-fade-transition :delay="1100">
                  <span :key="start ? 'started' : 'paused'">{{entradaPorcentaje | superDecimalInput}}%</span>
                </o-fade-transition>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center align-center class="primary--text bordeRayas" v-if="cuotas > 0">
              <v-flex xs11 sm4 md3 class="primary--text">
                <v-layout align-center>
                  <v-flex xs7 sm12 pl-3 :class="$vuetify.breakpoint.xsOnly ? 'pt-1' : ''" :style="$vuetify.breakpoint.xsOnly ? estiloBorde : ''">
                    <o-fade-transition :delay="1600">
                      <div :key="start ? 'started' : 'paused'">
                        <i18n path="reservas.resumenGrafico.pago" tag="span" class="hidden-xs-only">
                          <template #num>{{pasoCuotas}}</template>
                          <template #sup><sup>{{$t('reservas.resumenGrafico.paso' + pasoCuotas)}}</sup></template>                            
                        </i18n>
                          {{$tc('reservas.resumenGrafico.cuotas', numeroCuotas, {count: numeroCuotas})}}
                      </div>
                    </o-fade-transition>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex hidden-sm-and-up xs1/>
              <v-flex xs11 sm7 md8>
                <v-layout align-center>
                  <v-flex xs7 sm5 pb-2 pt-2 :style="estiloBorde">
                    <v-layout justify-end>
                      <o-scale-x-transition :right="false" :delay="1600">
                        <span :key="start ? 'started' : 'paused'" class="primary white--text text-xs-right pa-1 px-2" style="width:120px;">
                          <o-fade-transition :delay="2100">
                            <span :key="start ? 'started' : 'paused'">{{cuotas | currency}}</span>
                          </o-fade-transition>
                        </span>
                      </o-scale-x-transition>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="iva != null" xs5 sm6 class="primary--text">
                    <v-layout align-center>
                      <o-scale-x-transition :delay="1600">
                        <v-flex :key="start ? 'started' : 'paused'" class="primary--text rayas mr-2" style="max-width:40px;"/>
                      </o-scale-x-transition>
                      <o-fade-transition :delay="2100">
                        <span :key="start ? 'started' : 'paused'">{{cuotas * iva / 100 | currency}}</span>
                      </o-fade-transition>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="primary--text text-xs-right pr-3">
                <o-fade-transition :delay="1600">
                  <span :key="start ? 'started' : 'paused'">{{cuotasPorcentaje | superDecimalInput}}%</span>
                </o-fade-transition>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center align-center v-if="resto > 0">
              <v-flex xs11 sm4 md3 class="primary--text">
                <v-layout align-center>
                  <v-flex xs7 sm12 pl-3 :class="$vuetify.breakpoint.xsOnly ? 'pt-1' : ''" :style="$vuetify.breakpoint.xsOnly ? estiloBorde : ''">
                    <o-fade-transition :delay="2100">  
                      <div :key="start ? 'started' : 'paused'">
                          <i18n path="reservas.resumenGrafico.pago" tag="span" class="hidden-xs-only">
                            <template #num>{{pasoFinanciacion}}</template>
                            <template #sup><sup>{{$t('reservas.resumenGrafico.paso' + pasoFinanciacion)}}</sup></template>                            
                          </i18n>
                          {{$t('reservas.resumenGrafico.financiacion')}}
                      </div>
                    </o-fade-transition>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex hidden-sm-and-up xs1/>
              <v-flex xs11 sm7 md8>
                <v-layout align-center>
                  <v-flex xs7 sm5 pb-2 pt-2 :style="estiloBorde">
                    <v-layout justify-end>
                      <o-scale-x-transition :right="false" :delay="2100">
                        <span :key="start ? 'started' : 'paused'" class="primary white--text text-xs-right pa-1 px-2" style="width:90%;">
                          <o-fade-transition :delay="2600">
                            <span :key="start ? 'started' : 'paused'">{{resto | currency}}</span>
                          </o-fade-transition>
                        </span>
                      </o-scale-x-transition>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="iva != null" xs5 sm7 class="primary--text">
                    <v-layout align-center>
                      <o-scale-x-transition :delay="2100">
                        <v-flex :key="start ? 'started' : 'paused'" class="primary--text rayas mr-2" style="max-width:40%;"/>
                      </o-scale-x-transition>
                      <o-fade-transition :delay="2600">
                        <span :key="start ? 'started' : 'paused'">{{resto * iva / 100 | currency}}</span>
                      </o-fade-transition>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="primary--text text-xs-right pr-3">
                <o-fade-transition :delay="2100">
                  <span :key="start ? 'started' : 'paused'">{{restoPorcentaje | superDecimalInput}}%</span>
                </o-fade-transition>
              </v-flex>
            </v-layout>
            
            <v-layout row wrap justify-center align-center class="primary--text bordeRayasTop">
              <v-flex xs11 sm4 md3 class="primary--text">
                <v-layout align-center>
                  <v-flex xs7 sm12 pl-3 :class="$vuetify.breakpoint.xsOnly ? 'pt-1' : ''" :style="$vuetify.breakpoint.xsOnly ? estiloBorde : ''">
                    <o-fade-transition :delay="2100">  
                      <div :key="start ? 'started' : 'paused'">
                          {{$t('reservas.resumenGrafico.total')}}
                      </div>
                    </o-fade-transition>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex hidden-sm-and-up xs1/>
              <v-flex xs11 sm7 md8>
                <v-layout align-center>
                  <v-flex xs7 sm5 pb-2 pt-2 :style="estiloBorde">
                    <v-layout justify-end>
                      <o-scale-x-transition :right="false" :delay="2600">
                        <span :key="start ? 'started' : 'paused'" class="primary white--text text-xs-right pa-1 px-2" style="width:100%;">
                          <o-fade-transition :delay="3100">
                            <span :key="start ? 'started' : 'paused'">{{total | currency}}</span>
                          </o-fade-transition>
                        </span>
                      </o-scale-x-transition>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="iva != null" xs5 sm7 class="primary--text">
                    <v-layout align-center>
                      <o-scale-x-transition :delay="2600">
                        <v-flex :key="start ? 'started' : 'paused'" class="primary--text rayas mr-2" style="max-width:40%;"/>
                      </o-scale-x-transition>
                      <o-fade-transition :delay="3100">
                        <span :key="start ? 'started' : 'paused'">{{total * iva / 100 | currency}}</span>
                      </o-fade-transition>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="primary--text text-xs-right pr-3">
                <o-fade-transition :delay="2100">
                  <span :key="start ? 'started' : 'paused'">{{100 | superDecimalInput}}%</span>
                </o-fade-transition>
              </v-flex>
            </v-layout>


            <v-layout justify-center align-center>
              <v-flex hidden-xs-only sm4 md3 class="primary--text"/>
              <v-flex xs11 sm7 md8>
                <v-layout align-center>
                  <v-flex xs7 sm5 :style="estiloBorde">
                    <v-layout justify-end class="primary--text py-2 pl-2" style="font-size: 0.7rem">
                      <svg style="position:relative;left:6px;top:10px;" height="10" width="10" class="primary--text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <polygon points="0,0 20,0 10,20" style="fill:currentColor;" />
                      </svg>
                    </v-layout>
                  </v-flex>
                  <v-flex xs5 sm7 class="primary--text px-2" style="font-size: 0.7rem">
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="primary--text">
              </v-flex>
            </v-layout>
            <v-layout justify-center align-center>
              <v-flex hidden-xs-only sm4 md3 class="primary--text"/>
              <v-flex xs11 sm7 md8>
                <v-layout align-center>
                  <v-flex xs7 sm5>
                    <v-layout justify-end>
                      <o-fade-transition :delay="3100">
                        <svg :key="start ? 'started' : 'paused'" style="width:40px;height:40px;position:relative;left:20px;" class="primary--text" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.16 200.16">
                          <path d="M37.11,132.42c0-2.44.09-4.88,0-7.31-.07-1.36.74-2.08,1.48-2.87,1.2-1.28,2.48-2.48,3.75-3.69s2.54-2.25,3.72-3.46c1.46-1.49,2.79-3.12,4.25-4.62,1.13-1.15,2.38-2.17,3.55-3.27.79-.75,1.53-1.56,2.29-2.34l2.61-2.63,3.41-3.41C63,98,63.8,97.1,64.66,96.26l3.44-3.38,2.72-2.67a6.1,6.1,0,0,0,1.26-1.28c.18-.35.14-1.17-.1-1.33-.94-.63-.75-1.54-.76-2.37,0-2.76,0-5.52,0-8.28a5.4,5.4,0,0,1,.65-1.67c0-.11.21-.21.2-.28-.35-1.54.65-2.72,1.11-4a17.66,17.66,0,0,1,1.59-2.92,20.18,20.18,0,0,1,1.39-2.19,33.87,33.87,0,0,1,2.32-2.76,32.35,32.35,0,0,1,2.65-2.59,20.55,20.55,0,0,1,2.11-1.43c.45-.29.89-.59,1.34-.86l3.06-1.78a.49.49,0,0,1,.22-.1c1.86-.06,3.39-1.57,5.38-1.22a2.24,2.24,0,0,0,2.29-.64c.51-.58,4.1-.11,4.81.26a6.55,6.55,0,0,0,1.92.4c1,.16.8-.69,1.12-1.18.93-1.43.57-3,.71-4.52.08-.87-.24-1.88.8-2.45.08,0,.08-.21.12-.32a40,40,0,0,1,1.27-4.07A15.51,15.51,0,0,1,108,40.1c.08-.13.19-.29.17-.42-.19-1.13.77-1.68,1.31-2.35a44.19,44.19,0,0,1,3.59-3.78,26,26,0,0,1,3.46-3.19,37.55,37.55,0,0,1,4.45-2.2c1.21-.6,2.41-1.26,3.64-1.83a3.68,3.68,0,0,1,1.17-.18c1-.11,2,.2,2.74-.76.18-.23.76-.16,1.16-.17,2.68,0,5.36,0,8,0,.57,0,1.11.45,1.68.62a10.67,10.67,0,0,0,1.5.25c.91.12,2-.25,2.56.84,0,0,.07,0,.1.06,1.24.42,2.49.81,3.71,1.29a4,4,0,0,1,1.48.9c1.05,1.12,2.69,1.31,3.68,2.65s2.43,2.13,3.53,3.3a34.57,34.57,0,0,1,2.47,3.27c.32.42.65.84.94,1.29.59.89,1.17,1.79,1.71,2.71a6.38,6.38,0,0,1,.24.91c.15.38.39.73.52,1.11a11.74,11.74,0,0,1,.45,1.67c.14.82-.21,1.77.8,2.33.18.1.19.59.19.9,0,4,0,7.92,0,11.87a3.2,3.2,0,0,1-.54,1.22c-.09.17-.32.34-.31.49a8.19,8.19,0,0,1-1.15,4.54,43,43,0,0,1-2.16,3.79,17,17,0,0,1-1.74,2.37c-1.17,1.29-2.41,2.52-3.64,3.76a29.44,29.44,0,0,1-2.51,2.36,10.9,10.9,0,0,1-2.5,1.53,1.21,1.21,0,0,1-1.71-.54c-.62-1-1.68-1.74-1.93-3.07-.09-.49-.72-.92-1.16-1.3-1.06-.9-1-1.53.06-2.34a35.54,35.54,0,0,0,4.91-3.93c.91-1,2.23-1.77,2.51-3.39.15-.85,1-1.57,1.47-2.4a7.63,7.63,0,0,0,1.22-2.71c.22-2.67,1.54-5.19,1-8a29.73,29.73,0,0,0-1-4.93c-.65-1.69-2-3.12-2.56-4.83-.61-1.93-2.17-2.94-3.38-4.22a7.49,7.49,0,0,0-3.37-2.5,11.62,11.62,0,0,1-2.65-1.67,2.08,2.08,0,0,0-.8-.18c-.81-.09-1.69.09-2.25-.8-.11-.17-.6-.15-.91-.15-3,0-5.92,0-8.88,0a3.82,3.82,0,0,0-1.25.49c-.25.11-.5.25-.76.34-1.18.38-2.54.49-3.5,1.18-1.54,1.09-3.36,1.83-4.52,3.48-.65.93-1.71,1.58-2.45,2.46-.59.7-.9,1.62-1.47,2.33-.7.87-.67,2.22-1.21,2.83-1.17,1.31-.27,3.12-1.54,4.32-.4.38-.15,1.46-.16,2.22,0,1,0,2,0,3,0,1.87.58,2.58,2.3,3.25a4,4,0,0,1,1.31,1c1,1,2.11,2,3.06,3.15a16.73,16.73,0,0,1,1.25,2.09A25.84,25.84,0,0,1,122,69.31a37.09,37.09,0,0,1,1.34,3.75c.06.18,0,.47.12.57,1.23,1.05.68,2.5.91,3.77.09.56.58,1.06.63,1.61.14,1.83.61,3.66-.45,5.47-.39.67-.16,1.71-.25,2.58s.26,1.88-.8,2.44c-.1,0-.09.3-.13.45a20.33,20.33,0,0,1-1.33,3.92,48.49,48.49,0,0,1-3.38,4.6,21.27,21.27,0,0,1-1.48,1.89,24.56,24.56,0,0,1-2.16,1.91,17.61,17.61,0,0,1-1.48,1.09,44,44,0,0,1-4.49,2.84,21.87,21.87,0,0,1-3.92,1.13c-.23.06-.6,0-.69.1-.81,1.24-2.08.8-3.16.83q-3.84.09-7.68,0c-.55,0-1.08-.45-1.64-.63s-1.19-.66-1.8.28-1.69,1.49-2.33,2.38c-1.09,1.5-2.6,1.15-4,1.18-1,0-2.08,0-3.12,0a2.06,2.06,0,0,0-2.36,2.37c0,1.68,0,3.36,0,5,0,1-.34,1.5-1.46,1.45-1.84-.08-3.68,0-5.52,0-.78,0-1.07.25-1.05,1,0,1.72,0,3.44,0,5.16a2.49,2.49,0,0,1-2.6,2.61c-1.48,0-3,0-4.44,0-1.78,0-1.84.07-1.85,1.79,0,1.32-.07,2.65,0,4a3.66,3.66,0,0,1-1.83,3.52,21.73,21.73,0,0,0-2.29,2.31c-.75.73-1.53,1.44-2.32,2.13a.77.77,0,0,1-.55.07,18.2,18.2,0,0,0-2.62-.46c-3.36-.09-6.73,0-10.08-.17a16.18,16.18,0,0,1-4.09-1c-.24-.08-.43-.71-.44-1.09,0-2.56,0-5.12,0-7.68Zm67.68-67c-.75.64-1.53,1.22-2.19,1.91-.5.53-1.19,1.22-1.19,1.84,0,2.23-.93,4.65.89,6.62.79.85,1.67,2.18,2.57,2.23,2.23.14,4.61,1.06,6.77-.71.77-.64.62-1.11.29-1.55-.68-.9-1.61-1.6-2.29-2.5a32,32,0,0,1-2.42-3.68C106.44,68.16,106.18,66.45,104.79,65.41Z" transform="translate(-0.24 -0.24)"/><path d="M145.26,96.4c0,1.52.05,3,0,4.55a6.68,6.68,0,0,1-.58,1.44,8.88,8.88,0,0,0-.35,1.46c-.16.92.12,1.84-.8,2.7-.69.64-.76,1.91-1.2,2.86a12.17,12.17,0,0,1-1.47,2.55,48.34,48.34,0,0,1-4.66,5.13c-1,.89-1.92,2-3.46,2.34-.92.19-1.64,1.17-2.53,1.61a33,33,0,0,1-3.23,1.22,17,17,0,0,1-1.92.7,14.18,14.18,0,0,1-2.59.37c-.72,0-1.09.26-1.19,1,0,.34-.35.64-.53,1s-.43.55-.39.77c.23,1.25-.74,2-1.15,3a.33.33,0,0,1-.17.16,15.39,15.39,0,0,0-3,1.21,9.15,9.15,0,0,1-3.23,1.12c-.14,0-.13,1.07,0,1.62a4,4,0,0,0,.58,1.06c.23.43.44.85.64,1.29a4.54,4.54,0,0,1,.34,1c.11.7-.12,1.45.79,1.93.51.27.07,1.42-.57,1.73-1.28.62-2.54,1.28-3.82,1.89a2.46,2.46,0,0,1-1.15.27c-1.12-.06-1.42.57-1.27,1.49s-.12,1.73.79,2.57a5.87,5.87,0,0,1,1.19,3.19,2.21,2.21,0,0,1-2.12,2.65c-.73.11-1.51,0-1.95.88-.1.18-.62.1-.88.26a6,6,0,0,0-1.86,1.35c-.19.26.35,1.06.59,1.6,1,2.28,2,4.59,1.18,7.13a26.46,26.46,0,0,1-1.61,3.13,3.38,3.38,0,0,0-.26,1,2.69,2.69,0,0,1-2.69,2.67,6.61,6.61,0,0,0-1.57.65c-.07,0-.12.11-.2.13-1.46.44-2.92.85-4.38,1.3a10.22,10.22,0,0,0-1.31.6c-.07,0-.11.13-.18.15-1.46.4-2.92.77-4.37,1.19-.49.14-.92.47-1.4.62a3.26,3.26,0,0,1-1.46.22c-.23,0-.39-.58-.57-.9-.56-1-1.13-2-1.68-3.07-.37-.71-.72-1.43-1-2.16a13.09,13.09,0,0,0-1.38-3.16c-.93-1.13-.63-2.67-1.68-3.77-.5-.53-.41-1.66-1.13-2.28-.1-.09-.07-.42,0-.58.51-1,1-2.05,1.58-3.07,0-.07.14-.11.16-.18.38-1.15.71-2.33,1.15-3.47s1-2.3,1.54-3.45c.06-.14.22-.24.27-.39.43-1.26.78-2.56,1.29-3.79a30.21,30.21,0,0,1,1.53-2.93c.06-.11.16-.19.19-.3.4-1.26.73-2.55,1.21-3.79s1.4-2.5,1.68-3.84,1.36-2.14,1.44-3.58c.06-1.13,1-2.21,1.56-3.31,0-.07.12-.11.15-.18.39-1.2.7-2.42,1.18-3.58s1.08-2.17,1.6-3.26c.17-.35.22-.76.37-1.12.24-.59.53-1.16.78-1.74a1.54,1.54,0,0,0,.21-.66c-.11-1.25.65-1.44,1.64-1.42s1.84,0,2.76,0a2.6,2.6,0,0,0,2-.58c.46-.42,1.44-.24,2.18-.35,1-.15,2.19.39,2.9-.82.06-.09.3-.09.46-.11a11.57,11.57,0,0,0,4.67-1.83c.93-.58,2-.89,3-1.38.32-.17.49-.6.8-.79a16.36,16.36,0,0,0,4.85-3.92c.88-1.15,2.07-2.07,3-3.17a27.07,27.07,0,0,0,1.79-2.55l1.7-2.59a.8.8,0,0,0,.13-.19c.39-1.19.77-2.39,1.17-3.58.58-1.75,1.18-3.49,1.76-5.23a2.57,2.57,0,0,0,.13-.83c0-3.83,0-7.67,0-11.51a7.57,7.57,0,0,0-.3-1.38c-.08-.32-.14-.65-.2-1,.5,0,1.1-.2,1.49,0a14.88,14.88,0,0,1,2.64,1.81c.94.8,1.78,1.73,2.66,2.61s1.62,1.51,2.33,2.35a22.89,22.89,0,0,1,1.66,2.45c.57.9,1.11,1.82,1.67,2.73,0,0,.07,0,.08.08.39,1.19.76,2.37,1.17,3.55.18.52.45,1,.63,1.52a3.61,3.61,0,0,1,.29,1.14c0,1.6,0,3.2,0,4.8Z" transform="translate(-0.24 -0.24)"/>
                        </svg>
                      </o-fade-transition>
                    </v-layout>
                  </v-flex>
                  <v-flex xs5 sm7 class="primary--text px-2" style="font-size: 0.7rem">
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="primary--text">
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
</template>
<script>
export default {
  props: ['entrada', 'tarifa', 'iva', 'id', 'reserva', 'entradaPorcentaje', 'cuotas', 'resto', 'numeroCuotas', 'cuotasPorcentaje', 'restoPorcentaje', 'total'],
  data () {
    return {
      start: false
    }
  },
  computed: {
    estiloBorde () {
      return {
        'border-right': this.$vuetify.theme.primary + ' 2px solid'
      }
    },
    pasoEntrada () {
      if (this.reserva > 0) {
        return 2
      } else {
        return 1
      }
    },
    pasoCuotas () {
      let paso = 3
      if (this.reserva <= 0) {
        paso--
      }
      if (this.reserva == this.entrada) {
        paso--
      }
      return paso
    },
    pasoFinanciacion () {
      let paso = 4
      if (this.reserva <= 0) {
        paso--
      }
      if (this.reserva == this.entrada) {
        paso--
      }
      if (this.cuotas <= 0) {
        paso--
      }
      return paso
    }
  }
}
</script>

<style lang="stylus" scoped>
  .theme--light .pago-description-divider
    width 54px
    border-width 2px 0 0 0
  
  .rayas
    height 29px
    border currentColor 2px solid
    border-left none
    background-size 13px 13px
    background-repeat repeat
    background-image linear-gradient(-45deg, currentColor 25%,transparent 26%,transparent 50%,currentColor 50%,currentColor 75%,transparent 76%,transparent)

  .bordeRayas
    background-image: linear-gradient(to right, currentColor 75%, transparent 25%);
    background-position: left bottom;
    background-repeat: repeat-x;
    background-size: 20px 1px;
  
  .bordeRayasTop
    background-image: linear-gradient(to right, currentColor 75%, transparent 25%);
    background-position: left top;
    background-repeat: repeat-x;
    background-size: 20px 1px;
</style>



// WEBPACK FOOTER //
// src/components/reservas/condiciones/ResumenGrafico.vue